export const formatPhoneNumber = (phoneNumber: string): string => {
    const digitsOnly = phoneNumber.replace(/\D/g, '');

    if (digitsOnly.length === 0) {
        return '';
    }

    const withCountryCode = digitsOnly.startsWith('1') ? digitsOnly : '1' + digitsOnly;

    const limited = withCountryCode.slice(0, 11);

    if (limited.length <= 1) {
        return '+1';
    } else if (limited.length <= 4) {
        return `+1 (${limited.slice(1)}`;
    } else if (limited.length <= 7) {
        return `+1 (${limited.slice(1, 4)}) ${limited.slice(4)}`;
    } else {
        return `+1 (${limited.slice(1, 4)}) ${limited.slice(4, 7)}-${limited.slice(7)}`;
    }
}